import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  background-color: ${({ theme }) => theme.Components.Panel.Background};
  justify-content: space-between;
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.Components.Panel.BackgroundHover};
    border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  }
`;

export const StyledImage = styled.div<{ source: string }>`
  width: ${({ theme }) => utils.rem(theme.Icon.Size.XXLarge)};
  height: ${({ theme }) => utils.rem(theme.Icon.Size.XLarge)};
  border: ${({ theme }) => utils.rem(theme.Border.Size.Small)} solid
    ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  background-image: url(${({ source }) => source});
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;
